import { State } from './types'

const state: State = {
	addState: false,
	detail: null,
	applicationstate: false,
	appDetail: null
}

const mutations = {
	toggleBusinessAddState(state: { addState: boolean }, value: boolean) {
		state.addState = value
	},
	setBusinessDetail(state: { detail: null | Object }, value: Object | null) {
		state.detail = value
	},
	toggleAppAddState(state: { applicationstate: boolean }, value: boolean) {
		state.applicationstate = value
	},
	setAppAddDetail(state: { appDetail: null | Object }, value: Object | null) {
		state.appDetail = value
	}
}

export default {
	state,
	mutations
}
